import React from "react"
import { Link, NavLink } from "react-router-dom";
import { DashboardImg, ProjectImg, SideBarLogoImg, SidebarReLogoImg, UserDocImg, ProfileImg, InvestorsImg, PlatformImg, TemplateImg, UsersImg } from "./ImageConstants";
import Logout from "./Logout";
import * as Constants from "../partials/CommonConstant"
import { GetUser } from "./CommonController";

const SideMenu = (props) => {
  const userDetail = GetUser();

  const checkRole = () => {
    if (userDetail.role === 1 || userDetail.role === 2) {
      return true;
    }
    return false;
  }

  const checkRoleForClient = () => {
    if (userDetail.role !== 3) {
      return true;
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="l-sidebar">
        <div className="logo">
        </div>
        <div className="l-sidebar__content">
          <Link to={Constants.dashboard} className="logo-info">
            <img src={SideBarLogoImg} alt="sidebar-logo" className="expaned-img" />
            <img src={SidebarReLogoImg} alt="sidebar-logo" className="reduced-img" />
          </Link>
          <nav className="c-menu js-menu">
            <ul className="u-list">
              {checkRoleForClient() &&
                <NavLink to={Constants.dashboard} className={(menu) => {
                  return (
                    menu.isActive ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                  )
                }} data-toggle="tooltip" title="Dashboard">
                  <div className="c-menu__item__inner">
                    <span className="menu-icon-block">
                      <img src={DashboardImg} alt="Dashboard" />
                    </span>
                    <div className="c-menu-item__title"><span>Dashboard</span></div>
                  </div>
                </NavLink>
              }
              {checkRoleForClient() &&
                <NavLink className={(menu) => {
                  return (
                    props.location.pathname.includes("project") ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                  )
                }}
                  to={Constants.projectList} data-toggle="tooltip" title="Projects">
                  <div className="c-menu__item__inner">
                    <span className="menu-icon-block">
                      <img src={ProjectImg} alt="Projects" />
                    </span>
                    <div className="c-menu-item__title"><span>Projects</span></div>
                  </div>
                </NavLink>
              }
              {checkRole() &&
                <NavLink className={(menu) => {
                  return (
                    props.location.pathname.includes("user") ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                  )
                }}
                  to={Constants.users} data-toggle="tooltip" title="Users">
                  <div className="c-menu__item__inner">
                    <span className="menu-icon-block">
                      <img src={UsersImg} alt="Users" />
                    </span>
                    <div className="c-menu-item__title"><span>Users</span></div>
                  </div>
                </NavLink>
              }
              {/* <NavLink className={(menu) => {
                return (
                  (props.location.pathname.includes("files") || props.location.pathname.includes("add-file")
                    || props.location.pathname.includes("edit-file") || props.location.pathname.includes("view-file")
                    || props.location.pathname.includes("download-logs") || props.location.pathname.includes("add-folder")
                    || props.location.pathname.includes("view-folder")
                    || props.location.pathname.includes("edit-folder") || props.location.pathname.includes("upload-folder")) ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                )
              }}
                to={"#"} onClick={() => window.open("http://docman.quadringroup.com", "_blank")} data-toggle="tooltip" title="Docman">
                <div className="c-menu__item__inner">
                  <span className="menu-icon-block">
                    <img src={UserDocImg} alt="Users Documents" />
                  </span>
                  <div className="c-menu-item__title"><span>Docman</span></div>
                </div>
              </NavLink> */}
              {checkRole() &&
                <NavLink className={(menu) => {
                  return (
                    props.location.pathname.includes("investor") ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                  )
                }}
                  to={Constants.investors} data-toggle="tooltip" title="Investors">
                  <div className="c-menu__item__inner">
                    <span className="menu-icon-block">
                      <img src={InvestorsImg} alt="Investors" />
                    </span>
                    <div className="c-menu-item__title"><span>Investors</span></div>
                  </div>
                </NavLink>
              }







              {checkRole() &&
                <NavLink className={(menu) => {
                  return (
                    props.location.pathname.includes("platform") ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                  )
                }}
                  to={Constants.platforms} data-toggle="tooltip" title="Platforms">
                  <div className="c-menu__item__inner">
                    <span className="menu-icon-block">
                      <img src={PlatformImg} alt="Platforms" />
                    </span>
                    <div className="c-menu-item__title"><span>Platforms</span></div>
                  </div>
                </NavLink>
              }
              {checkRole() &&
                <NavLink className={(menu) => {
                  return (
                    props.location.pathname.includes("template") || props.location.pathname.includes("questions") ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                  )
                }}
                  to={Constants.templates} data-toggle="tooltip" title="Templates">
                  <div className="c-menu__item__inner">
                    <span className="menu-icon-block">
                      <img src={TemplateImg} alt="Templates" />
                    </span>
                    <div className="c-menu-item__title"><span>Templates</span></div>
                  </div>
                </NavLink>
              }

              <NavLink to={Constants.profile} className={(menu) => {
                return (
                  (props.location.pathname.includes("profile") || props.location.pathname.includes("site-logs") || props.location.pathname.includes("session-logs")) ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                )
              }} data-toggle="tooltip" title="Profile">
                <div className="c-menu__item__inner">
                  <span className="menu-icon-block">
                    <img src={ProfileImg} alt="Profile" />
                  </span>
                  <div className="c-menu-item__title"><span>Profile</span></div>
                </div>
              </NavLink>

              <NavLink className={(menu) => {
                return (
                  props.location.pathname.includes("translate") ? "c-menu__item has-submenu is-active" : "c-menu__item has-submenu"
                )
              }}
                to={Constants.translate} data-toggle="tooltip" title="Translate">
                <div className="c-menu__item__inner">
                  <span className="menu-icon-block">
                    {/* <img src={InvestorsImg} alt="Translate" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" fill={props.location.pathname.includes("translate") ? `#ee7608` : 'white'} width="30" height="30" viewBox="0 0 100 100">
                      <path d="M 19 13 C 15.698375 13 13 15.698375 13 19 L 13 67 C 13 70.301625 15.698375 73 19 73 L 47.695312 73 L 52.048828 86.310547 A 1.0001 1.0001 0 0 0 53 87 L 81.210938 87 C 84.385019 87 87 84.412578 87 81.246094 L 87 33 C 87 29.698375 84.301625 27 81 27 L 52.310547 27 L 47.951172 13.689453 A 1.0001 1.0001 0 0 0 47 13 L 19 13 z M 19 15 L 46.275391 15 L 50.625 28.277344 A 0.50005 0.50005 0 0 0 50.634766 28.310547 L 61.902344 62.703125 L 61.908203 62.724609 L 63.03125 66.152344 L 64.619141 71 L 48.421875 71 L 19 71 C 16.779625 71 15 69.220375 15 67 L 15 19 C 15 16.779625 16.779625 15 19 15 z M 23.5 18 C 20.477273 18 18 20.477273 18 23.5 L 18 25.5 A 0.50005 0.50005 0 1 0 19 25.5 L 19 23.5 C 19 21.022727 21.022727 19 23.5 19 L 43.5 19 A 0.50005 0.50005 0 1 0 43.5 18 L 23.5 18 z M 51.914062 29 L 81 29 C 83.220375 29 85 30.779625 85 33 L 85 81.246094 C 85 83.31361 83.302856 85 81.210938 85 L 54.505859 85 L 65.669922 71.847656 L 65.691406 71.824219 A 0.50005 0.50005 0 0 0 65.785156 71.34375 L 64.087891 66.160156 C 64.462565 65.864843 65.819066 64.773538 68.148438 62.464844 C 70.241872 64.742892 72.848087 67.665493 76.285156 70.867188 A 0.50005 0.50005 0 0 0 76.980469 70.855469 L 79.294922 68.539062 A 0.50005 0.50005 0 0 0 79.277344 67.814453 C 75.607671 64.484245 72.964742 61.596532 70.927734 59.40625 C 73.514049 56.312556 76.141258 52.674294 76.871094 49 L 81.5 49 A 0.50005 0.50005 0 0 0 82 48.5 L 82 45.5 A 0.50005 0.50005 0 0 0 81.5 45 L 70 45 L 70 40.5 A 0.50005 0.50005 0 0 0 69.5 40 L 64.5 40 A 0.50005 0.50005 0 0 0 64 40.5 L 64 45 L 57.154297 45 L 51.914062 29 z M 33.998047 31.001953 C 27.376801 31.001953 21.998047 36.380707 21.998047 43.001953 C 21.998047 49.623252 27.378806 55 34 55 C 40.621246 55 46 49.621246 46 43 C 46 42.100465 45.893142 41.228643 45.707031 40.390625 A 0.50005 0.50005 0 0 0 45.21875 40 L 34.5 40 A 0.50005 0.50005 0 0 0 34 40.5 L 34 44.5 A 0.50005 0.50005 0 0 0 34.5 45 L 40.625 45 C 39.754023 47.872289 37.162528 50 34 50 C 30.12824 50 27 46.87176 27 43 C 27 39.12824 30.12824 36 34 36 C 35.816085 36 37.460196 36.69446 38.705078 37.828125 A 0.50005 0.50005 0 0 0 39.394531 37.8125 L 42.222656 34.984375 A 0.50005 0.50005 0 0 0 42.210938 34.267578 C 40.064931 32.248789 37.176624 31.001953 33.998047 31.001953 z M 56.5 32 A 0.50005 0.50005 0 1 0 56.5 33 L 57.5 33 A 0.50005 0.50005 0 1 0 57.5 32 L 56.5 32 z M 60.5 32 A 0.50005 0.50005 0 1 0 60.5 33 L 65.5 33 A 0.50005 0.50005 0 1 0 65.5 32 L 60.5 32 z M 70.5 32 A 0.50005 0.50005 0 1 0 70.5 33 L 76.5 33 C 78.977273 33 81 35.022727 81 37.5 L 81 39.5 A 0.50005 0.50005 0 1 0 82 39.5 L 82 37.5 C 82 34.477273 79.522727 32 76.5 32 L 70.5 32 z M 33.998047 32.001953 C 36.72523 32.001953 39.160377 33.067104 41.082031 34.710938 L 38.962891 36.830078 C 37.593398 35.726179 35.896242 35 34 35 C 29.58776 35 26 38.58776 26 43 C 26 47.41224 29.58776 51 34 51 C 37.86477 51 41.098269 48.252 41.839844 44.599609 A 0.50005 0.50005 0 0 0 41.349609 44 L 35 44 L 35 41 L 44.775391 41 C 44.898263 41.653822 45 42.313631 45 43 C 45 49.080754 40.080754 54 34 54 C 27.919194 54 22.998047 49.082654 22.998047 43.001953 C 22.998047 36.921199 27.917293 32.001953 33.998047 32.001953 z M 65 41 L 69 41 L 69 45.5 A 0.50005 0.50005 0 0 0 69.5 46 L 81 46 L 81 48 L 76.5 48 A 0.50005 0.50005 0 0 0 76.005859 48.421875 C 75.444302 51.987575 72.627591 55.89007 69.888672 59.130859 A 0.50005 0.50005 0 0 0 69.904297 59.794922 C 71.870479 61.906464 74.646906 64.884978 78.236328 68.183594 L 76.630859 69.787109 C 73.289658 66.635528 70.59383 63.660606 68.539062 61.431641 A 0.50005 0.50005 0 0 0 67.814453 61.419922 C 65.051882 64.232706 64.065067 64.883704 63.744141 65.111328 L 62.966797 62.742188 C 63.200407 62.557751 64.828669 61.266082 66.357422 59.703125 A 0.50005 0.50005 0 0 0 66.369141 59.017578 C 63.515581 55.876219 62.593251 53.771666 62.285156 53 L 64.714844 53 C 64.906312 53.364967 65.809167 55.045468 67.771484 57.326172 A 0.50005 0.50005 0 0 0 68.535156 57.320312 C 70.539851 54.915889 72.712938 52.009489 73.669922 48.636719 A 0.50005 0.50005 0 0 0 73.189453 48 L 58.138672 48 L 58.136719 48 L 57.482422 46 L 64.5 46 A 0.50005 0.50005 0 0 0 65 45.5 L 65 41 z M 58.464844 49 L 72.412109 49 C 71.507164 51.654316 69.868824 54.059635 68.162109 56.150391 C 66.537431 54.111568 65.447266 52.277344 65.447266 52.277344 A 0.50005 0.50005 0 0 0 65 52 L 61.5 52 A 0.50005 0.50005 0 0 0 61.025391 52.658203 C 61.025391 52.658203 62.11755 55.594548 65.332031 59.28125 C 64.180638 60.406365 63.128126 61.297075 62.630859 61.712891 L 58.464844 49 z M 18.492188 59.992188 A 0.50005 0.50005 0 0 0 18 60.5 L 18 62.5 C 18 65.522727 20.477273 68 23.5 68 L 40.5 68 A 0.50005 0.50005 0 1 0 40.5 67 L 23.5 67 C 21.022727 67 19 64.977273 19 62.5 L 19 60.5 A 0.50005 0.50005 0 0 0 18.492188 59.992188 z M 47.5 67 A 0.50005 0.50005 0 1 0 47.5 68 L 55.5 68 A 0.50005 0.50005 0 1 0 55.5 67 L 47.5 67 z M 58.5 67 A 0.50005 0.50005 0 1 0 58.5 68 L 59.5 68 A 0.50005 0.50005 0 1 0 59.5 67 L 58.5 67 z M 49.472656 72 L 64.230469 72 L 53.576172 84.548828 L 49.472656 72 z M 81.492188 73.992188 A 0.50005 0.50005 0 0 0 81 74.5 L 81 76.5 C 81 78.990687 78.990687 81 76.5 81 L 61.5 81 A 0.50005 0.50005 0 1 0 61.5 82 L 76.5 82 C 79.531313 82 82 79.531313 82 76.5 L 82 74.5 A 0.50005 0.50005 0 0 0 81.492188 73.992188 z"></path>
                    </svg>
                  </span>
                  <div className="c-menu-item__title"><span>Translate</span></div>
                </div>
              </NavLink>

              <a
                className={
                  props.location.pathname.includes("template") || props.location.pathname.includes("questions")
                    ? "c-menu__item has-submenu"
                    : "c-menu__item has-submenu"
                }
                href="https://quadrin.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                title="Templates"
              >
                <div className="c-menu__item__inner">
                  <span className="menu-icon-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42L17.59 5H14V3zM5 5h5V3H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-5h-2v5H5V5z" />
                    </svg>

                  </span>
                  <div className="c-menu-item__title"><span>Netlify</span></div>
                </div>
              </a>


              <Logout logoutType="sidemenu" />
            </ul>
          </nav>

          <div className="sidebar-img-wrap">
            <div className="heading">
              <h2>Qflow</h2>
            </div>
          </div>

        </div>
      </div>
    </React.Fragment>
  )
}

export default SideMenu